module.exports = __webpack_public_path__ + "056436e644f227766f412a5dd3553e65.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/heros/api-hero.png
// module id = 775
// module chunks = 0